export default function ColonialDivider() {
  return (
    <div className="w-full bg-white py-8 md:py-12 flex items-center justify-center">
      <div className="flex items-center gap-4 md:gap-6 max-w-4xl mx-auto px-6">
        {/* Left ornament */}
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-primary/40" />
          <div className="w-8 md:w-16 h-px bg-gradient-to-r from-primary/40 to-primary/20" />
        </div>
        {/* Center diamond */}
        <div className="relative flex items-center justify-center">
          <div className="w-3 h-3 rotate-45 bg-primary/30" />
          <div className="absolute w-1.5 h-1.5 rotate-45 bg-primary/60" />
        </div>
        {/* Right ornament */}
        <div className="flex items-center gap-2">
          <div className="w-8 md:w-16 h-px bg-gradient-to-l from-primary/40 to-primary/20" />
          <div className="w-2 h-2 rounded-full bg-primary/40" />
        </div>
      </div>
    </div>
  );
}